/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { Route } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import { AppBar, Toolbar } from '@mui/material'

import Navigation from 'components/Navigation'
import { logout } from 'redux/auth/actions'
import jwtDecode from 'jwt-decode'
import MenuAvatar from 'components/MenuAvatar'
import Colors from 'utils/Colors'

import history from 'utils/history'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { gotoUrl } from 'utils/functions'
import MobileNavigation from 'components/MobileNavigation'

import { Logout, People, Source } from '@mui/icons-material'
import styles from './styles'

const SignedInLayout = ({ component: Component, ...rest }) => {
  const classes = styles()
  const dispatch = useDispatch()

  const token = useSelector((state) => state.auth.access_token)
  const full_name = jwtDecode(token).extras.name.split(' ')
  const username =
    full_name.length > 1 ? `${full_name[0]} ${full_name[full_name.length - 1]}` : full_name[0]

  const decoded = jwtDecode(token)

  const handleLogout = () => {
    dispatch(logout())
    gotoUrl(ROUTE_CONSTANTS.LOGIN)
  }

  const handleRestrictions = () => {
    history.push(ROUTE_CONSTANTS.RESTRICTIONS_OPTIONS)
    history.go()
  }

  const handleUserManagement = () => {
    history.push(ROUTE_CONSTANTS.USER_MANAGEMENT)
    history.go()
  }

  const menuOptions = [{ text: 'Sair', action: handleLogout, icon:  <Logout /> }]

  if (
    ['PROC_KEYWORD_LIST', 'CNAE_LIST', 'COMPLIANCE_FETCH'].some((keyword) =>
      decoded.extras.scopes.includes(keyword),
    )
  ) {
    menuOptions.unshift({
      text: 'Opções Restritivas',
      action: handleRestrictions,
      icon: <Source />,
    })
  }

  if (decoded.extras.scopes.includes('USER_LIST')) {
    menuOptions.unshift({
      text: 'Gerenciamento de Usuários',
      action: handleUserManagement,
      icon: <People />,
    })
  }

  const renderMainBar = () => (
    <div className={classes.root}>
      <AppBar position="fixed" style={{ backgroundColor: Colors.headerColor }}>
        <Toolbar>
          <div className={classes.navbar}>
            <div className={classes.mobileNavigation}>
              <MobileNavigation />
            </div>
            <div className={classes.titleContainer}>
              <img src="/assets/images/logos/client_logo.png" alt="Logo" className={classes.logo} />
              <img
                src="/assets/images/logos/Dimensa_Logo_Pref_Neg_RGB.svg"
                alt="Logo By Dimensa branco"
                className={classes.logoDimensa}
              />
              <h2>KYP</h2>
              <div className={classes.navigation}>
                <Navigation />
              </div>
            </div>

            <MenuAvatar username={username} options={menuOptions} />
          </div>
        </Toolbar>
      </AppBar>
    </div>
  )

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <div>
          {renderMainBar()}
          <Component {...matchProps} />
        </div>
      )}
    />
  )
}

export default SignedInLayout
